import { render, staticRenderFns } from "./About.vue?vue&type=template&id=dbe991fa&scoped=true&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=dbe991fa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe991fa",
  null
  
)

component.options.__file = "About.vue"
export default component.exports